import { render, staticRenderFns } from "./IfFormField.vue?vue&type=template&id=fa311b5a&"
import script from "./IfFormField.vue?vue&type=script&lang=js&"
export * from "./IfFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports